/**
 * Created by choizhang on 2018/3/1.
 */

import demoCN from './demo/zh-cn'
import demoHK from './demo/zh-hk'
import demoEN from './demo/en'
import globalCN from './global/zh-cn'
import globalHK from './global/zh-hk'
import globalEN from './global/en'
import easterCN from './easter/zh-cn'
import easterHK from './easter/zh-hk'
import easterEN from './easter/en'
import questionCN from './question/zh-cn'
import questionHK from './question/zh-hk'
import questionEN from './question/en'
import concertCN from './concert/zh-cn'
import concertHK from './concert/zh-hk'
import concertEN from './concert/en'
import birthdayEN from './birthday/en'
import birthdayCN from './birthday/zh-cn'
import birthdayHK from './birthday/zh-hk'
import shareEN from './share/en'
import shareCN from './share/zh-cn'
import shareHK from './share/zh-hk'
import greenchannelpassingEN from './greenchannel/passing/en'
import greenchannelpassingCN from './greenchannel/passing/zh-cn'
import greenchannelpassingHK from './greenchannel/passing/zh-hk'
import drawEN from './greenchannel/draw/en'
import drawCN from './greenchannel/draw/zh-cn'
import drawHK from './greenchannel/draw/zh-hk'
import greenchannelEN from './greenchannel/en'
import greenchannelCN from './greenchannel/zh-cn'
import greenchannelHK from './greenchannel/zh-hk'
import mobileDeviceEN from './mobileDevice/en'
import mobileDeviceCN from './mobileDevice/zh-cn'
import mobileDeviceHK from './mobileDevice/zh-hk'
import paymentRuleEN from './paymentRule/en'
import paymentRuleCN from './paymentRule/zh-cn'
import paymentRuleHK from './paymentRule/zh-hk'
import everyDaySpecialEN from './everyDaySpecial/en'
import everyDaySpecialCN from './everyDaySpecial/zh-cn'
import everyDaySpecialHK from './everyDaySpecial/zh-hk'
import otherEN from './other/en'
import otherCN from './other/zh-cn'
import otherHK from './other/zh-hk'
import registerEN from './register/en'
import registerCN from './register/zh-cn'
import registerHK from './register/zh-hk'
import luckyEN from './lucky/en'
import luckyCN from './lucky/zh-cn'
import luckyHK from './lucky/zh-hk'
import activity5GEN from './activity5G/en'
import activity5GCN from './activity5G/zh-cn'
import activity5GHK from './activity5G/zh-hk'
import SystemMaintenanceEN from './SystemMaintenance/en'
import SystemMaintenanceCN from './SystemMaintenance/zh-cn'
import SystemMaintenanceHK from './SystemMaintenance/zh-hk'
import FPS_EN from './FPS/en'
import FPS_CN from './FPS/zh-cn'
import FPS_HK from './FPS/zh-hk'
import selectSkinEN from './selectSkin/en.json'
import selectSkinCN from './selectSkin/zh-cn.json'
import selectSkinHK from './selectSkin/zh-hk.json'

export default {
    en: {
        demo: demoEN,
        global: globalEN,
        easter: easterEN,
        question: questionEN,
        concert: concertEN,
        birthday: birthdayEN,
        share: shareEN,
        greenchannel: greenchannelEN,
        greenchannelpassing: greenchannelpassingEN,
        draw:drawEN,
        mobileDevice: mobileDeviceEN,
        paymentRule: paymentRuleEN,
        everyDaySpecial: everyDaySpecialEN,
        other: otherEN,
        register: registerEN,
        lucky: luckyEN,
        activity5G: activity5GEN,
        SystemMaintenance: SystemMaintenanceEN,
        FPS: FPS_EN,
        selectSkin: selectSkinEN,
    },
    sc: {
        demo: demoCN,
        global: globalCN,
        easter: easterCN,
        question: questionCN,
        concert: concertCN,
        birthday: birthdayCN,
        share: shareCN,
        greenchannel: greenchannelCN,
        greenchannelpassing: greenchannelpassingCN,
        draw:drawCN,
        mobileDevice: mobileDeviceCN,
        paymentRule: paymentRuleCN,
        everyDaySpecial: everyDaySpecialCN,
        other: otherCN,
        register: registerCN,
        lucky: luckyCN,
        activity5G: activity5GCN,
        SystemMaintenance: SystemMaintenanceCN,
        FPS: FPS_CN,
        selectSkin: selectSkinCN,
    },
    tc: {
        demo: demoHK,
        global: globalHK,
        easter: easterHK,
        question: questionHK,
        concert: concertHK,
        birthday: birthdayHK,
        share: shareHK,
        greenchannel: greenchannelHK,
        greenchannelpassing: greenchannelpassingHK,
        draw:drawHK,
        mobileDevice: mobileDeviceHK,
        paymentRule: paymentRuleHK,
        everyDaySpecial: everyDaySpecialHK,
        other: otherHK,
        register: registerHK,
        lucky: luckyHK,
        activity5G: activity5GHK,
        SystemMaintenance: SystemMaintenanceHK,
        FPS: FPS_HK,
        selectSkin: selectSkinHK,
    },
}



// WEBPACK FOOTER //
// ./src/locale/index.js